import { Button } from "@clockwise/design-system";
import { TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";
import React from "react";
import { useFeatureFlag } from "../../../launch-darkly/useLaunchDarkly";
import { track } from "../../../util/analytics.util";
import { useUpdateSuggestedPrompt } from "../ai-chat/hooks/SuggestedPromptContext";

const SUGGESTED_PROMPTS = ["Find time with @", "Reschedule @"];
const SUGGESTED_PROMPTS_V2 = ["Find time with @", "Reschedule #"];

export const ChatInputSuggestions = () => {
  const updatePromptText = useUpdateSuggestedPrompt();
  const [hasChatInputV2] = useFeatureFlag("rollout-ai-chat-chat-input-v-2");

  const setupInputSuggestion = (prompt: string) => {
    updatePromptText(prompt);
    track(TrackingEvents.CHAT.CHAT_RECOMMENDATION_ABOVE_INPUT_CLICKED, { text: prompt });
  };

  return (
    <div className="cw-flex cw-items-center cw-gap-2 cw-px-4 cw-mb-2">
      {hasChatInputV2 ? (
        // TODO: active development @scott in https://linear.app/getclockwise/issue/AI-4761/[epic]-chat-input-improvements
        <>
          {SUGGESTED_PROMPTS_V2.map((prompt) => {
            return (
              <Button
                key={prompt}
                sentiment="neutral"
                variant="outlined"
                size="mini"
                onClick={() => {
                  setupInputSuggestion(prompt);
                }}
              >
                {prompt}
              </Button>
            );
          })}
        </>
      ) : (
        <>
          {SUGGESTED_PROMPTS.map((prompt) => {
            return (
              <Button
                key={prompt}
                sentiment="positive"
                variant="outlined"
                rounded
                size="small"
                onClick={() => {
                  setupInputSuggestion(prompt);
                }}
              >
                {prompt}
              </Button>
            );
          })}
        </>
      )}
    </div>
  );
};
